import classNames from 'classnames'
import {FC, ReactNode} from 'react'

export type RightViewHeadingProps = {
  children: ReactNode
  classes?: string
  dataCy?: string
}

/**
 * A simple heading component that can be used in the right view of the page.
 */
export const RightViewHeading: FC<RightViewHeadingProps> = ({
  classes,
  children,
  dataCy,
}) => {
  return (
    <h1
      data-cy={dataCy}
      className={classNames('abc-light text-2xl', classes, {
        'mb-6': !classes,
      })}
    >
      {children}
    </h1>
  )
}
